import React from "react"
import RyderLivescoringHolesNin9rsView from "@/components/RyderLivescoring/views/nin9rs/RyderLivescoringHolesNin9rsView"
import RyderLivescoringHolesDefaultView from "@/components/RyderLivescoring/views/default/RyderLivescoringHolesDefaultView"

function RyderLivescoringHoles ({ holes, team1Id, team2Id, teamColors, match = {}, customDesign }) {
    const matchDate = match.date
        ? new Date(match.date.date).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
        })
        : ""

    const matchHour = match.hour
        ? new Date(match.hour.date).toLocaleString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        })
        : ""

    const hasDateToShow = matchDate || matchHour

    if ("nin9rs" === customDesign) {
        return <RyderLivescoringHolesNin9rsView
            holes={holes}
            team1Id={team1Id}
            team2Id={team2Id}
            teamColors={teamColors}
            hasDateToShow={hasDateToShow}
            matchDate={matchDate}
            matchHour={matchHour}
        />
    } else {
        return <RyderLivescoringHolesDefaultView
            holes={holes}
            team1Id={team1Id}
            team2Id={team2Id}
            teamColors={teamColors}
            hasDateToShow={hasDateToShow}
            matchDate={matchDate}
            matchHour={matchHour}
        />
    }
}

export default RyderLivescoringHoles
